import { Box, CircularProgress, Typography } from '@mui/material';

export function LoadingState({ message = 'Carregando...' }: { message?: string }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, py: 8 }}>
      <CircularProgress size={24} />
      <Typography color="text.secondary">{message}</Typography>
    </Box>
  );
}

export function EmptyState({ message = 'Nenhum registro encontrado.' }: { message?: string }) {
  return (
    <Box sx={{ textAlign: 'center', py: 8 }}>
      <Typography color="text.secondary">{message}</Typography>
    </Box>
  );
}
